<template>
  <footer class="c-footer">
    <div class="withearth">
      <div class="withearth__wrap">
        <img loading="lazy" class="logo" src="/lp/assets/img/common/logo.png" alt="WITH EARTH GARDEN" width="197" height="138">
        <hr>
        <a class="web-link" href="https://www.withearth.jp/bunjyo/?utm_source=withearthgarden-jp&utm_medium=website&utm_campaign=lp-202407" target="_blank">
          ウィザースガーデン ウェブサイト
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="25" viewBox="0 0 40 25" fill="none">
            <rect y="0.5" width="40" height="24" rx="8" fill="#FFF738"/>
            <path d="M12 12C11.7239 12 11.5 12.2239 11.5 12.5C11.5 12.7761 11.7239 13 12 13V12ZM28.3536 12.8536C28.5488 12.6583 28.5488 12.3417 28.3536 12.1464L25.1716 8.96447C24.9763 8.7692 24.6597 8.7692 24.4645 8.96447C24.2692 9.15973 24.2692 9.47631 24.4645 9.67157L27.2929 12.5L24.4645 15.3284C24.2692 15.5237 24.2692 15.8403 24.4645 16.0355C24.6597 16.2308 24.9763 16.2308 25.1716 16.0355L28.3536 12.8536ZM12 13H28V12H12V13Z" fill="#275231"/>
          </svg>
        </a>
      </div>
    </div>
    <div class="shinshowa">
      <div class="shinshowa__wrap">
        <div class="logo-ixs">
          <picture>
              <source media="(max-width: 800px)" srcset="/lp/assets/img/lp/footer/logo-shinshowa-ixs-sp.png">
              <img loading="lazy" src="/lp/assets/img/lp/footer/logo-shinshowa-ixs-pc.png" alt="新昭和 iXS イクス" width="220" height="98">
          </picture>
        </div>
        <div class="logo-group">
          <img loading="lazy" src="/lp/assets/img/lp/footer/logo-shinshowa-group.png" alt="新昭和グループ" width="180" height="24">
          <small>Copyright © SHINSHOWA iXS <br class="u-none-b--sp">CORPORATION All Rights Reserved.</small>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
}
</script>